import React from 'react';

const IconLinkedin = () => {
  return (
    <div>
      <svg
        width="41"
        height="40"
        viewBox="0 0 41 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="0.161804" width="40" height="40" rx="8" fill="black" />
        <path
          d="M31.4298 31.25H26.763V23.9417C26.763 22.1989 26.7319 19.9555 24.3359 19.9555C21.9052 19.9555 21.5333 21.8542 21.5333 23.8148V31.2494H16.8667V16.2206H21.3466V18.2744H21.4095C22.3216 16.7148 24.024 15.7798 25.8297 15.8469C30.5596 15.8469 31.4317 18.9579 31.4317 23.0054L31.4298 31.25ZM11.601 14.1662C10.1154 14.1662 8.89227 12.9438 8.89227 11.4582C8.89227 9.97251 10.1148 8.75 11.6005 8.75C13.086 8.75 14.3084 9.97223 14.3086 11.4576C14.3086 12.943 13.0864 14.1661 11.601 14.1662ZM13.9343 31.25H9.26278V16.2206H13.9343V31.25Z"
          fill="white"
        />
      </svg>
    </div>
  );
};

export default IconLinkedin;
